import PropTypes from 'prop-types'
import DestinationModalCountryCard from './DestinationModalCountryCard'
import { DestinationModalContinentListQuery, DestinationsModalCountryDetailsQuery, DestinationsModalDetailsQuery } from 'gql/graphql'

type DestinationModalViewPropertiesCardProps = {
  data: DestinationsModalCountryDetailsQuery
    |DestinationsModalDetailsQuery
    | undefined
  dataType: 'country' | 'all'
  selectedContinent: DestinationModalContinentListQuery['continents'][number] | null
}

const DestinationModalViewPropertiesCard = ({
  data,
  dataType,
  selectedContinent,
}: DestinationModalViewPropertiesCardProps) => {
  switch (dataType) {
    case 'country':
      const countryData = data as DestinationsModalCountryDetailsQuery

      return (
        <DestinationModalCountryCard
          image={countryData?.country?.random_region?.main_media}
          href={`/${countryData?.country?.slug}`}
          propertyCount={countryData?.country?.property_count ?? 0}
          text={countryData?.country?.value}
        />
      )
    case 'all':
    default:
      const allData = data as DestinationsModalDetailsQuery

      return (
        <DestinationModalCountryCard
          image={allData?.randomRegion?.main_media}
          href={{
            pathname: '/search',
            query: selectedContinent
              ? {
                continents: selectedContinent?.id,
              }
              : undefined,
          }}
          propertyCount={selectedContinent?.property_count ?? allData?.propertyCount ?? 0}
        />
      )
  }
}

DestinationModalViewPropertiesCard.propTypes = {
  data: PropTypes.object,
  dataType: PropTypes.oneOf(['country', 'all']),
}

export default DestinationModalViewPropertiesCard
